export class Suggestion {
	title;
	slug;
	image;
	gallery;
	content;
	excerpt;
	date;
	hashtags;
	exhibitions;
	
	constructor (object)
	{
		// Info
		this.id = object.id || null;
		this.slug = object.slug || null;
		this.title = object.title.rendered || null;
		this.date = object.date || null;
		this.status = object.status || null;

		// Content
		this.author = object.meta_box.author || null;
		this.authorProfession = object.meta_box.profession || null;
		this.image = object.meta_box.image || null;
		this.suggestions = object.meta_box.suggestions || null;	
	}
}


// WEBPACK FOOTER //
// ./src/data/classes/suggestion.class.js